<template>
  <div>
    <zj-layout-container
      v-loading="loading"
      element-loading-text="加载中..."
    >
      <zj-layout-header>
        <div class="listtitle">预警历史记录</div>
        <el-form
          class="zj-search-form"
          ref="queryForm"
          :model="queryParams"
          :label-width="labelWidth"
        >
            <el-form-item label="预警名称" prop="warnName">
                <el-input
                  v-model="queryParams.warnName"
                  placeholder="请输入预警名称"
                ></el-input>
            </el-form-item>
            <el-form-item label="设备名称" prop="equipmentName">
                <el-input
                  v-model="queryParams.equipmentName"
                  placeholder="请输入预警设备名称"
                ></el-input>
            </el-form-item>
            <el-form-item label="选择日期">
                <el-date-picker
                v-model="dateRange"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width:60rem;"
                unlink-panels
                :clearable="false"
                ></el-date-picker>
            </el-form-item>

            <el-form-item label class="right">
                <el-button @click="onSearch">查 询</el-button>
                <el-button @click="onCancel">清 理</el-button>
            </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table :data="warnRecordList" border style="width: 100%" fixed>
              <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
              <el-table-column prop="warnName" label="预警名称"></el-table-column>
              <el-table-column prop="equipmentName" label="设备名称"></el-table-column>
              <el-table-column prop="equipmentCode" label="设备Code"></el-table-column>
              <el-table-column prop="startTs" label="上报时间" :formatter="formatterDate1"></el-table-column>
              <el-table-column prop="severityTranslated" label="预警级别">
                <template slot-scope="scope">
                  <span v-if="scope.row.warnColor == null">{{scope.row.severityTranslated}}</span>
                  <span v-if="scope.row.warnColor == '1'" style="color: dodgerblue;">{{scope.row.severityTranslated}}</span>
                  <span v-if="scope.row.warnColor == '2'" style="color: yellow;">{{scope.row.severityTranslated}}</span>
                  <span v-if="scope.row.warnColor == '3'" style="color: orange;">{{scope.row.severityTranslated}}</span>
                  <span v-if="scope.row.warnColor == '4'" style="color: red;">{{scope.row.severityTranslated}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="warnDesc" label="预警信息"></el-table-column>
              
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <el-button
                    @click="handleDetail(scope.row)"
                    type="text"
                    size="small"
                  >查看</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParams.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="queryParams.pageSize"  
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>

    <!-- 查看预警详情 -->
    <el-dialog title="查看预警详情" v-if="detail" :visible.sync="detail" width="800px">
        <el-form ref="form" label-width="80px" size="mini" :class="{middleOutLine:showMap}">
            <el-row>
                <el-form-item label="预警名称：">{{ form.warnName }}</el-form-item>
                <el-form-item label="预警级别：">{{ form.severityTranslated }}</el-form-item>
                <el-form-item label="上报时间：" >{{ formatterDate1(form) }}</el-form-item>
                <el-form-item label="预警信息：">{{ form.warnDesc }}</el-form-item>
                <el-form-item label="设备名称：">{{ form.equipmentName }}</el-form-item>
                <el-form-item label="设备Code：">{{ form.equipmentCode }}</el-form-item>
                <el-form-item label="图片：" v-if="form.images">
                  <img :src="form.images" alt="" style="width: 500px; height: 200px;">
                </el-form-item>
                <el-form-item label="处理时间：">{{ formatterDate2(form) }}</el-form-item>
                <el-form-item label="处理详情：">{{ form.actDesc }}</el-form-item>
                <div class="mapBox" v-show="showMap">
                  <!--  ref="map-mapview" -->
                  <div class="covermap">
                    <div
                      class="map"
                      id="allmapIndex"
                      style="width: 100%; height: 100%; z-index: 2 !important"
                    ></div>
                  </div>

                  <div class="coverbg"></div>
                </div>
            </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">关 闭</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import { listWarnRecord, getWarnRecordById } from '@/api/src/warnMessage'
export default {
  name: "ElaryWarningHistoryList",
  controller: "UI",
  action: "ElaryWarningHistoryList",
  dicts: [
    'warn_color',
    'again_warn_time_interval'
  ],
  data() {
    return {
      // 遮罩层
      loading: false,
      // 总条数
      total: 0,
      // 日历时间
      dateRange: null,
      // 查询参数
      queryParams: {
        warnStatus: '2',
        warnName: '',
        equipmentName: '',
        beginTime: null,
        endTime: null,
        pageNum: 1,
        pageSize: 10
      },
      // 表格数据
      warnRecordList: [],
      // 是否显示弹出层
      detail: false,
      form: {},
      mapInstance:null,
      showMap:false
    };
  },
  created: function() {
    this.getList();
    this.logInfo.ActionName = "预警历史记录查询";
    this.logInfo.LogMessage = "预警历史记录查询";
    this.logInfo.ModuleName = "预警系统";
    this.logInfo.PageName = "预警历史记录列表";
    this.addOperationLog();
  },
  watch: {
    $route() {
      this.getList();
    }
  },
  methods: {
    // 查询
    getList() {
      this.loading = true;
      this.queryParams.beginTime = this.dateRange != null ? this.dateRange[0] : null;
      this.queryParams.endTime = this.dateRange != null ? this.dateRange[1] : null;
      this.queryParams.id = this.$route.query.warnConfigId || '';
      if(global.$config.app.project=="loufanwenlv"){
        this.queryParams.systemCode = "travel";
      }
      listWarnRecord(this.queryParams).then(response =>{
        this.warnRecordList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    // 格式化表格时间
    formatterDate1(row){
      return this.getDate(row.startTs);
    },
    formatterDate2(row){
      return this.getDate(row.ackTs);
    },
    // 时间戳转xxxx-xx-xx
    getDate(time){
      let tempTime = new Date(time);
      let year = tempTime.getFullYear();
      let month = tempTime.getMonth()+1;
      let day = tempTime.getDate();
      let hour = tempTime.getHours();
      let min = tempTime.getMinutes();
      let sec = tempTime.getSeconds();
      hour = hour < 10 ? "0" + hour : hour;
      min = min < 10 ? "0" + min : min;
      sec = sec < 10 ? "0" + sec : sec;
      return year + '-' + month + '-' + day + ' ' + hour + ':' + min + ':' + sec;
    },
    // 点击查询按钮
    onSearch() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    // 点击清理按钮
    onCancel() {
      this.resetForm("queryForm");
      this.dateRange = null;
      this.$route.query.warnConfigId = null;
      this.onSearch();
    },
    // 查看详情
    handleDetail(row){
      getWarnRecordById(row.id).then(res => {
        this.form = res.data;
        this.detail = true;
        let center = [];
        if((res.data.lat && res.data.lng)){
          center.push(res.data.lng)
          center.push(res.data.lat)
          this.showMap=true
          this.init(() =>{
            this.onDrawMap(center)
          })
        }else if(res.data.coordinate){
          let coordinate = JSON.parse(res.data.coordinate)
          this.showMap=true
          this.init(() =>{
            this.onDrawMap('',coordinate)
          })
        }
      });
    },
     init(fun){
      let that = this;
      var mapConfigs = {};
      this.$nextTick(function () {
        // eslint-disable-next-line no-undef
        $(function () {
          // 不传入 syscode 和 key ，或者值为空时，
          // zjumap 插件自动从 URL 地址
          // http://HOST:PORT/Areas/Map/Content/UMap.html?syscode=xxx&key=yyy
          // 中读取 syscode 和 key 的值。
          // eslint-disable-next-line no-undef
          $(".map").zjumap({
            syscode: "ZJMap",
            key: "DefaultMap",
            loading: ".global-loading",
            loadingText: ".global-loading-text",
            //地图配置
            // eslint-disable-next-line no-undef
            mapConfigs: $.extend(
              {},
              {
                mapStyle: "",
                togglePanelVisiable: false,
                mapLayers: "",
                reportGeo: true,
                // onGotGeo: function (e) {
                //   e.handled = true;
                //   // if (that.marker) {
                //   //   that.marker.setPosition(
                //   //     e.map.newPoint(e.point.lng, e.point.lat)
                //   //   );
                //   // } else {
                //     //that.marker = that.addMarker(e.map, e.point);
                //   // }
                // },
                // onAreaDrawn: function (e) {
                //   that.onAreaDrawn(e.data.points);
                // },
                // onPolygonEditorComplete: function (e) {
                //   that.onAreaDrawn(e.data);
                // },
                onMapCreated: function (e) {
                  that.mapInstance = e.map;
                  e.map.clearAll();
                  // that.center = e.map.config.center;
                  fun()
                },
              },
              mapConfigs
            ),
          });
        });
      });
    },
    onDrawMap(center,coordinate){
        var map = this.mapInstance
        if(center){
          var point = new BMap.Point(center[0] || 0, center[1] || 0);
          map.centerAndZoom(point, 12);
          var marker = new BMap.Marker(point); // 创建标注
          marker.setAnimation(BMAP_ANIMATION_BOUNCE); //跳动的动画
          let labelString = "暂无法获取位置";
          if (center.length > 0) {
            labelString ="(" + center[0] + "," + center[1] + ")";
          }

          var label = new BMap.Label(labelString, {
            offset: new BMap.Size(20, -10),
          });
          marker.setLabel(label);
          map.addOverlay(marker); // 将标注添加到地图中
          map.setViewport([point]);
        }else{
          var point = new BMap.Point(coordinate[0].Longitude, coordinate[1].Latitude);
          map.centerAndZoom(point, 12);
          let pointArr = []
          coordinate.map(item =>{
            pointArr.push(new BMap.Point(item.Longitude, item.Latitude))
          })
          map.drawPolygon(pointArr, 1)
          map.setViewport(pointArr);
        }
    },
    // 关闭详情
    close(){
      this.detail = false;
    },
    // 点击每页显示的条数
    handleSizeChange(val){
      this.queryParams.pageSize = val;
      this.getList();
    },
    // 点击切换到某页
    handleCurrentChange(val){
      this.queryParams.pageNum = val;
      this.getList();
    },
  },
};
</script>
<style scoped>
::v-deep .el-form-item .el-form-item__content{
  display: inline-flex;
}
::v-deep .el-dialog__body{
    padding: 10px 20px;
}
::v-deep .el-dialog > div:not(:first-child).el-dialog__body{
    padding-top: 20px;
}
::v-deep .el-dialog .el-form-item__label{
  padding: 0;
}
  .mapBox {
    width: 100%;
    height: 274px;
    padding: 24px 20px 16px 26px;
    box-sizing: border-box;
    position: relative;
  }
  .covermap {
    position: absolute;
    top: 37px;
    left: 50%;
    width: 86%;
    height: 77%;
    z-index: 2;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .coverbg {
    width: 100%;
    height: 274px;
    background: url("../../../../../../assets/mapborder.png") no-repeat;
    background-size: 100%;
    position: absolute;
    left: 0px;
    top: 0px;
  }
  .middleOutLine{
    height: 54.8rem;
    overflow: auto;
  }
</style>